<template>
    <div class="container">
        <div class="bottom">
            <div class="logo">
                <img :src="logo" alt="">
            </div>
            <div class="iconBtn" @click="jumpNav">
                <i class="iconfont icon-mobile_navigation_zhankai" v-show="isShowNav"></i>
                <i class="iconfont icon-mobile_navigation_shouqi" v-show="!isShowNav"></i>
            </div>
        </div>
        <div class="float" v-show="isShowNav">
            <nav-list
                :routes="routes"
                @changeIsShowNav="changeIsShowNav"
                @close="onCloseNav">
            </nav-list>
        </div>
    </div>
</template>

<style lang='scss' scoped>
    .container{
        position: fixed;
        top:0;
        display: flex;
        align-items: center;
        height: 1.27rem;
        width: 10rem;
        padding: 0 .53rem;
        z-index: 99;
        background-color: #fff;
        box-shadow: 0 0 10px rgba(0,0,0,.3);
        .bottom{        
            display: flex;   
            justify-content: space-between;
            align-items: center;
            width: 100%;
            .logo img {
                height: 0.8rem;
                max-width: 8rem;
            }
            .iconBtn {
                font-size: 0.42rem; 
                vertical-align: middle;
            }
        }
    }
</style>

<script>
import { mapState } from 'vuex'
import { PaasTenant } from '@/models/paas-tenant'
import { RouteArr } from '@/models/route-arr'
import NavList from './nav-list'
export default {
    name:'MHeader',
    data() {
        return {
            isShowNav:false,
            routes: {
                data: []
            }
        }
    },
    components:{
        NavList,
    },
    computed: {
        ...mapState({
            logo: 'logo'
        })
    },
    created() {
        this.init()
    },
    methods: {
        init(){
            PaasTenant.getNavListM().then(res=>{
                this.routes = new RouteArr(res)
                const active_route = res.find(r => `/${window.location.hash}` === r.path)
                if(active_route){
                    this.routes.setActive(active_route)
                }
                
            })
        },
        jumpNav(){
            this.isShowNav = !this.isShowNav
        },
        changeIsShowNav(val){
            this.isShowNav = val
        },
        onCloseNav(){
            this.isShowNav = false
        },
        
    },
}
</script>


// WEBPACK FOOTER //
// src/components/layout/m-header/index.vue